import cn from 'classnames';

import { DateCardMedia_Items_IconMap, getObjectByEnumMap } from 'js/utils/enum-string-maps';

import Icon, { type IconName } from 'components/icon/Icon';
import LinkWrapper from 'components/link-wrapper/LinkWrapper';

import { DateCardMedia_Items_Icon, IDateCardMedia } from 'source/NFR.types';

const supportedIcons: Record<string, { name: IconName; fill: boolean }> = {
  slideshow: { name: 'slideshow', fill: true },
  video: { name: 'video', fill: true },
  camera: { name: 'camera', fill: false }
};

interface IDateCardMediaProps extends IDateCardMedia {
  className?: string;
}

const DateCardMedia: React.FC<IDateCardMediaProps> = ({ className, items = [] }) => (
  <div className={cn('date-card-media', className)}>
    {items?.map(({ url, icon, text }) => {
      const { OuterLink } = LinkWrapper(!!url, url);
      const iconObject = getObjectByEnumMap(DateCardMedia_Items_IconMap, supportedIcons, icon);

      return (
        <OuterLink
          className={cn('date-card-media-item', {
            'date-card-media-item--theme-black': icon === DateCardMedia_Items_Icon.Camera
          })}
          key={icon}
          title={text}
          href={url}
        >
          {iconObject && (
            <span className="date-card-media-icon">
              <Icon {...iconObject} />
            </span>
          )}
          {text && <span className="date-card-media-text">{text}</span>}
        </OuterLink>
      );
    })}
  </div>
);

DateCardMedia.displayName = 'DateCardMedia';

export default DateCardMedia;
